<script>
    export let text;
    export let color;
</script>

<div class="alert" style:color>
    <i class="icon-warning-fill" />
    
    <div class="alert-title">
        {text}
    </div>
</div>

<style>
    .alert {
        margin: 10px 0 30px 0;
        display: flex;
        align-items: center;
    }

    .alert-title {
        margin-left: 6px;
        font-size: 16px;
        line-height: 23px;
    }
</style>